// extracted by mini-css-extract-plugin
export default {"ChannelPageContent":"ChannelPage_ChannelPageContent__7j68v","ChannelPageContainer":"ChannelPage_ChannelPageContainer__7guSY"};